import { dbui_v1_OperationalAlert } from '@antimatterhq/asl-api-ts-v1';
import { exhaustiveMatchingGuard } from '@/utils/util';

export const getAlertStatusText = (
  state?: dbui_v1_OperationalAlert['state'],
) => {
  switch (state) {
    case 'dismissed':
      return 'Dismissed';
    case 'exported':
      return 'Exported';
    case 'dismissedAsDuplicate':
      return 'Dismissed as Duplicate';
    case 'exportedAsDuplicate':
      return 'Exported as Duplicate';
    case 'open':
      return 'Open';
    case null:
    case undefined:
      return undefined;
    default:
      exhaustiveMatchingGuard(state);
  }
};
